// src/components/form/DynamicMetricFeed.tsx
import React from 'react';
import { Flex, Text } from '@radix-ui/themes';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/database/client';
import { Metric } from '@/database/types';
import { NumberMetricInput } from '@/components/Form/NumberMetricInput';
import { ScaleMetricInput } from '@/components/Form/ScaleMetricInput';

export function DynamicMetricFeed() {
  const definitions = useLiveQuery(() => db.metrics.toArray(), []);
  // todo: refactor this to the repository, sort appropriately

  if (!definitions) {
    return (
      <Text size="2" color="gray">
        Loading stationery...
      </Text>
    );
  }

  return (
    <Flex direction="column" gap="3">
      {definitions.map((def: Metric) => {
        switch (def.type) {
          case 'number':
            return <NumberMetricInput key={def.id} definition={def} />;

          case 'scale':
            return <ScaleMetricInput key={def.id} definition={def} />;

          case 'counter':
            console.log(`Rendering input for: ${def.type}`);
            // Future implementation: Stepper (+ / - buttons) for volumetric data like water
            return null;

          default:
            console.warn(`Unsupported metric input kind: ${def.type}`);
            return null;
        }
      })}
    </Flex>
  );
}
